(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["og-welcome-popup"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('og-welcome-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'og-welcome-dismissed-v1';
  let opened = false;
  let ready = false;
  const engaged = () => window.scrollY >= Math.max(120, (document.documentElement.scrollHeight - window.innerHeight) * 0.25);
  let previousFocus;
  const dismissed = () => {
    try { return Date.now() - Number(localStorage.getItem(key) || 0) < 30 * 86400000; } catch { return false; }
  };
  const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch {} };
  const show = () => {
    if (opened || !ready || !engaged() || document.visibilityState !== 'visible' || dismissed() || document.querySelector('dialog[open], cart-drawer-component[open], details[open]')) return;
    opened = true;
    previousFocus = document.activeElement;
    dialog.showModal();
    remember();
  };
  const close = () => {
    remember();
    dialog.close();
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
  };
  dialog.querySelector('.og-welcome-close').addEventListener('click', close);
  dialog.querySelector('.og-welcome-dismiss').addEventListener('click', close);
  dialog.querySelector('.og-welcome-apply').addEventListener('click', remember);
  dialog.addEventListener('cancel', () => { remember(); });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  setTimeout(() => { ready = true; show(); }, Math.max(20, Number(dialog.dataset.delay) || 20) * 1000);
  window.addEventListener('scroll', show, {passive:true});
  if (dialog.dataset.editor === 'true') { ready = true; previousFocus = document.activeElement; dialog.showModal(); }
})();

  } catch(e) { console.error(e); }
})();
})();
